const optimaConfigConstants = {
  algorithmType: {
    DEFAULT: 1,
    CUSTOM: 2,
    FDP: 3,
    COURIER: 4,
  },
  algorithmTypeMap: {
    1: 'DEFAULT',
    2: 'CUSTOM',
    3: 'FDP',
    4: 'COURIER',
  },
  optimaTypeMap: {
    '2D': 1,
    LBH: 2,
    TELESCOPIC: 3,
    DELIVERY_WINDOW: 4,
  },
  optimaType: {
    1: '2D',
    2: 'LBH',
    3: 'TELESCOPIC',
    4: 'DELIVERY_WINDOW',
  },
  optimaStatus: {
    CREATED: 1,
    INPROGRESS: 2,
    COMPLETED: 3,
    FAILED: 4,
    REJECTED: 5,
    PROCESS: 6,
    INFRA_ISSUE: 7,
  },
  erpStatus: {
    CREATED: 1,
    INPROGRESS: 2,
    COMPLETED: 3,
    FAILED: 4,
    REJECTED: 5,
    PROCESS: 6,
    HOLD: 7,
    ALL_DEPOT: 8,
  },
  combineType: {
    CONSIGNEE: 0,
    MATERIAL: 1,
    LOCATION: 2,
    MATERIAL_CLUSTER: 3,
  },
  ptlContracts: {
    NO_PTL: 0,
    PTL_DIRECT_INDENT_WITHOUT_OPTIMA: 1,
    PTL_PASS_IT_TO_OPTIMA: 2,
  },
  FrequencyType: {
    INTERVAL: 'interval',
    ACTUAL: 'actual',
  },
  pickupThreshold: { weight: 5000, volume: 400 },
  floorOne: { weight: 3000, volume: 363 },
  floorTwo: { weight: 90, volume: 90 },
  dcMovementType: {
    VIA_HUB: {
      name: 'via hub',
      value: 0,
    },
    DIRECT_MOVEMENT: {
      name: 'direct movement',
      value: 1,
    },
  },
  customFieldTypes: {
    NUMBER: 'number',
    STRING: 'string',
    DATE: 'date',
  },
  customFieldLevel: {
    DROP_OFF: 'drop_off',
    MATERIAL: 'material',
  },
  optimaMaterialModes: {
    standalone: 'STANDALONE',
    parent: 'PARENT',
    child: 'CHILD',
  },

  additionalMovementMapping: {
    HYBRID: 'HYBRID',
  },
  activity: {
    PICKUP: 'pickup',
    DROP_OFF: 'drop_off',
  },
  picklistType: {
    ERP: 1,
    UPLOAD: 2,
  },
};
const optimaEditMode = {
  combineIndent: {
    type: 1,
    short_code: 'C',
  },
  splitIndent: {
    type: 2,
    short_code: 'S',
  },
};
const optimaRejectionReason = {
  PICKUP: 'PickUp not available / inactive in master',
  SHIP_TO: 'Ship-To not available / inactive in master',
  SOLD_TO: 'Sold-To not available / inactive in master',
  CONTRACT: 'Contract not available for %(pickUpRefId)s',
  OPTIMA_PTL_CONTRACT_MISSING: 'PTL Contract not available for %(pickUpRefId)s',
  OPTIMA_PTL_DATE_MISMATCH: 'Optima PTL not matching today date %(materialDate)s',
  DOCK: 'Dock not available in the master',
  DISPATCH_SCHEDULE: 'Dispatch Schedule Not Enabled for Current Day',
  PICKUP_COORDINATES_INVALID: 'Pickup coordinates invalid',
  CONSIGNEE_COORDINATES_INVALID: 'Dropoff coordinates invalid',
  COMPLETE_DEVLIVERY_REJECTION: 'Complete Delivery Rejection',
};

const MaterialUploadDateFormats = ['DD-MMM-YY', 'DD-MMMM-YYYY', 'DD-MM-YYYY', 'DD/MM/YYYY', 'YYYY-MM-DDTHH:mm:ss.sssZ', 'YYYY-MM-DD HH:mm:ss', 'YYYY/MM/DD HH:mm:ss', 'YYYY/MM/DD', 'YYYY-MM-DD'];
const getModeOfOptimaExecution = () => ({ VIA_INTEGRATION: 'VIA_INTEGRATION', VIA_MANUAL: 'VIA_MANUAL' });
const getOptimaRejectionStages = () => ({ DELIVERY_PICKLIST_STAGE: 'DELIVERY_PICKLIST_STAGE', PRE_OPTIMA_STAGE: 'PRE_OPTIMA_STAGE', POST_OPTIMA_STAGE: 'POST_OPTIMA_STAGE' });
const getMaxRejectionsCountForDownloadDirectly = () => 500;
const getMovementTypes = () => ({
  PRIMARY: 'PRIMARY', SECONDARY: 'SECONDARY', INWARD: 'INWARD', FORWARD: 'FORWARD', RETURN: 'RETURN', ROUND_TRIP: 'ROUND_TRIP',
});

// TODO: @siva @brantan let us sync when we merge vendor/return movement.
const getMovementMap = () => ({
  1: 'SECONDARY',
  2: 'PRIMARY',
});

const Optima = {
  optimaMaterialsHeader: {
    'Sales Doc./Delivery Number/Material Invoice Number': 'delivery',
    'Material Code': 'code',
    'Order Quantity': 'quantity',
    'Quantity Unit': 'bun', // it is quantity unit, god only knows why it is named as 'bun'
    Weight: 'weight',
    'Weight Unit': 'wunit',
    Volume: 'volume',
    'Volume Unit': 'vunit',
    'Pickup Ref Id': 'pickup_refid',
    'Customer/Ship To Ref Id': 'ship_refid',
    'Sold To Ref Id': 'sold_refid',
    Category: 'category',
    'Sub Category': 'sub_category',
    'Line Item': 'item_desc',
    'Date(YYYY-MM-DD)': 'date',
    STN: 'stn',
    'Material Category': 'material_category',
    'Invoice Date(YYYY-MM-DD)': 'invoice_date',
    'Invoice Value': 'invoice_value',
    'Category Priority': 'category_priority',
    'Transporter Reference Id': 'transporter_ref_id',
    MRP: 'mrp',
    'Vehicle Requirement Date': 'vehicle_requirement_date',
    'Dock Ref Id': 'dock_ref_id',
  },
  validationMessage: {
    GATE_REFERENCE: 'Gate reference id does not exist or Consignee reference does not exist / inactive',
    MATERIAL_CODE: 'Material code does not exist',
    SHIP_TO: 'Ship-To reference id does not exist / inactive',
    SOLD_TO: 'Sold-To reference id does not exist / inactive',
    TRANSPORTER_REF_ID: 'Transporter reference id does not exist',
    PACKAGE_ID: 'Package reference id does not exist',
    PACKAGE_PROPERTY: 'Package ref id, package weight and package volume are mandatory if group id is sent',
  },
  mitmEndpoints: {
    MITM_OPTIMA_DELIVERY_PICKLIST_INTERFACE_KEY: 'mitm_optima_delivery_picklist_rejection',
    MITM_OPTIMA_PRE_OPTIMA_INTERFACE_KEY: 'mitm_optima_pre_optima_rejection',
    MITM_OPTIMA_POST_OPTIMA_INTERFACE_KEY: 'mitm_optima_post_optima_rejection',
    MITM_OPTIMA_DISCARDED_ORDERS_INTERFACE_KEY: 'mitm_optima_discarded_orders',
    DELIVERY_PICKLIST: 'delivery_picklist_rejection',
    PRE_OPTIMA: 'pre_optima_rejection',
    POST_OPTIMA: 'post_optima_rejection',
    OPTIMA_DISCARDED_ORDERS: 'optima_discarded_orders',
  },
  fillMasterMaterialConstants: {
    1: 'material_parameters',
    2: 'material_associates',
  },
};

const defaultOrderCreation= {
  Newest: 'Newest',
  Oldest: 'Oldest',
};

const defaultCategoryPriorities = {
  Oneway: 'one-way',
  Twoway: 'two-way'
};

const optimaDeliveryPicklistHeaderMapping = {
  mandatoryHeaders: [
    'delivery_number',
    'material_code',
    'gate_ref_id',
    'quantity',
    'quantity_unit',
    'weight',
    'weight_unit',
    'volume',
    'volume_unit',
    'ship_to',
    'sold_to',
  ],
  nonMandatoryHeaders: [
    'type',
    'delivery_type',
    'delivery_date',
    'lr_number',
    'ext_ref_id',
    'transporter_ref_id',
    'invoice_date',
    'invoice_value',
    'mrp',
    'stock_norm_ratio',
    'vehicle_requirement_date',
    'delivery_status',
    'preferred_movement_via',
    'via_hub',
    'production_time',
    'dock_ref_id',
    'virtual_pickup_id',
    'virtual_ship_to_id',
    'virtual_sold_to_id',
    'custom_fields',
    'category',
    'category_priority',
    'stn',
    'date',
    'division',
    'group_id',
    'package_volume',
    'package_weight',
    'invoice_number',
    'order_type',
    'thickness',
    'load_sequence',
    'can_telescope',
    'sub_category',
    'package_ref_id',
  ],
  lastMileHeaders: [
    'customer_name',
    'customer_ref_id',
    'customer_rname',
    'customer_address',
    'customer_city',
    'customer_state',
    'customer_pincode',
    'customer_region',
    'customer_country',
    'customer_rmobile',
    'customer_remail',
    'customer_type',
    'customer_category',
    'customer_delivery_do_not_combine',
    'customer_combine',
    'customer_vehicle_type_exclude',
  ],
};

const toursolverVehicleUploadHeaders = {
  Team: 'team',
  Organization: 'organization',
  Email: 'email',
  Name: 'name',
  Phone: 'phone',
  'Address (Departure)': 'departure_address',
  'Postal code (Departure)': 'departure_postal_code',
  'City (Departure)': 'departure_city',
  'Country (Departure)': 'departure_country',
  'Longitude (Departure)': 'departure_longitude',
  'Latitude (Departure)': 'departure_latitude',
  'Address (Arrival)': 'arrival_address',
  'Postal code (Arrival)': 'arrival_postal_code',
  'City (Arrival)': 'arrival_city',
  'Country (Arrival)': 'arrival_country',
  'Longitude (Arrival)': 'arrival_longitude',
  'Latitude (Arrival)': 'arrival_latitude',
  'Fuel type': 'fuel_type',
  'Means of transportation': 'means_of_transportation',
  'Average fuel consumption': 'average_fuel_consumption',
  'Fuel cost': 'fuel_cost',
  'Characteristics': 'characteristics',
  'Speed weighting': 'speed_weighting',
  'Vehicle capacity (Weight)': 'vehicle_capacity_weight',
  'Vehicle capacity (03)': 'vehicle_capacity_03',
  'Vehicle capacity (Volume)': 'vehicle_capacity_volume',
  'Vehicle capacity (04)': 'vehicle_capacity_04',
  'Vehicle capacity (05)': 'vehicle_capacity_05',
  'Vehicle capacity (06)': 'vehicle_capacity_06',
  'Vehicle capacity (07)': 'vehicle_capacity_07',
  'Vehicle capacity (08)': 'vehicle_capacity_08',
  'Vehicle capacity (09)': 'vehicle_capacity_09',
  'Vehicle capacity (10)': 'vehicle_capacity_10',
  'Vehicle capacity (11)': 'vehicle_capacity_11',
  'Vehicle capacity (12)': 'vehicle_capacity_12',
  'Vehicle capacity (13)': 'vehicle_capacity_13',
  'Vehicle capacity (14)': 'vehicle_capacity_14',
  'Vehicle capacity (15)': 'vehicle_capacity_15',
  'Vehicle capacity (16)': 'vehicle_capacity_16',
  'Vehicle capacity (17)': 'vehicle_capacity_17',
  'Vehicle capacity (18)': 'vehicle_capacity_18',
  'Vehicle capacity (19)': 'vehicle_capacity_19',
  'Vehicle capacity (20)': 'vehicle_capacity_20',
  'Vehicle capacity (21)': 'vehicle_capacity_21',
  'Vehicle capacity (22)': 'vehicle_capacity_22',
  'Vehicle capacity (23)': 'vehicle_capacity_23',
  'Vehicle capacity (24)': 'vehicle_capacity_24',
  'Daily work time': 'daily_work_time',
  'Weekly work time': 'weekly_work_time',
  'Briefing duration': 'briefing_duration',
  'Debriefing duration': 'debriefing_duration',
  'Maximum daily distance': 'maximum_daily_distance',
  'Maximum visits per day': 'maximum_vists_per_day',
  'Global capacity': 'global_capacity',
  'Minimum quantity to deliver': 'minimum_quantity_to_deliver',
  'Maximum number of reloads/unloads': 'maximum_reloads',
  'Exceeded reloads/unloads penalty': 'exceeded_reloads',
  'Depot compatibility': 'depot_compatibility',
  'Loading duration': 'loading_duration',
  'Loading duration per unit': 'loading_duration_per_unit',
  'Unloading duration': 'unloading_duration',
  'Unloading duration per unit': 'unloading_duration_per_unit',
  'Hourly cost': 'hourly_cost',
  'Fixed cost of the resource used': 'fixed_cost_of_resource_used',
  'Resource daily cost not used': 'resource_daily_cost_not_used',
  'Fixed visit cost': 'fixed_visit_cost',
  'Resource request cost': 'resource_request_cost',
  'Cost per mile': 'cost_per_mile',
  'Cost per mile (Threshold) 2': 'cost_per_mile_threshold_2',
  'Cost per mile 2': 'cost_per_mile_2',
  'Cost per mile (Threshold) 3': 'cost_per_mile_threshold_3',
  'Cost per mile 3': 'cost_per_mile_3',
  'Cost per mile (Threshold) 4': 'cost_per_mile_threshold_4',
  'Cost per mile 4': 'cost_per_mile_4',
  'Overtime (Number) 1': 'overtime_number_1',
  'Overtime (Overcost) 1': 'overtime_overcost_1',
  'Overtime (Number) 2': 'overtime_number_2',
  'Overtime (Overcost) 2': 'overtime_overcost_2',
  'Identifier': 'identifier',
  'Vehicle identifier in WEBFLEET': 'vehicle_identifier_in_webfleet',
  'Available': 'available',
  'Automatic start time': 'automatic_start_time',
  'Lunch break (Start)': 'lunch_break_start',
  'Lunch break (End)': 'lunch_break_end',
  'Lunch break (Duration)': 'lunch_break_duration',
  'Worked days 1': 'worked_days_1',
  'Worked days 2': 'worked_days_2',
  'Worked days 3': 'worked_days_3',
  'Worked days 4': 'worked_days_4',
  'Work time - Start 1': 'work_time_start_1',
  'Work time - End 1': 'work_time_end_1',
  'Work time - Start 2': 'work_time_start_2',
  'Work time - End 2': 'work_time_end_2',
  'Work time - Start 3': 'work_time_start_3',
  'Work time - End 3': 'work_time_end_3',
  'Work time - Start 4': 'work_time_start_4',
  'Work time - End 4': 'work_time_end_4',
  'Start at first visit': 'start_at_first_visit',
  'End at last visit': 'end_at_last_visit',
  'Measure distance from first visit': 'measure_distance_from_first_visit',
  'Measure time from first visit': 'measure_time_from_first_visit',
  'Stop distance measurement at last visit': 'stop_distance_measurement_at_last_visit',
  'Stop time measurement at last visit': 'stop_time_measurement_at_last_visit',
  'Use all capacities': 'use_all_capacities',
  'First stop at depot': 'first_stop_at_depot',
  'Last stop at depot': 'last_stop_at_depot',
  'Reload/unload': 'reload_unload',
  'Pay whole day': 'pay_whole_day',
  'Max consecutive nights out': 'max_consecutive_nights_out',
  'Night out cost': 'night_out_cost',
  'Max drive time back before night out': 'max_drive_time_back_before_night_out',
  'Daily drive duration': 'daily_drive_duration',
  'Night out rest duration': 'night_out_rest_duration',
  'Max drive duration without break': 'max_drive_duration_without_break',
  'Drive break duration': 'drive_break_duration',
  'Drive break min duration': 'drive_break_min_duration',
  'Drive break at customer': 'drive_break_at_customer',
  'Drive break at depot': 'drive_break_at_depot',
  'Advanced planning': 'advanced_planning',
  'Active overnights': 'active_overnights',
  'Parking time': 'parking_time',
};

const toursolverOrderUploadHeaders = {
  "Name": "name",
  "Address": "address",
  "Lat": "lat",
  "Long": "long",
  "Postal code": "pincode",
  "City": "city",
  "Opening days 1": "opening_days_1",
  "Opening time 1": "opening_time_1",
  "Closing time 1": "closing_time_1",
  "Quantity": "quantity",
  "Visit duration": "visit_duration",
  "Loading/unloading duration per unit" : "loading_unloading_duration_per_unit",
  "Last delivery date": "last_delivery_date",
  "Visit frequency": "visit_frequency",
  "Minimum spacing between visits": "minimum_spacing_between_visits",
  "Maximum spacing between visits": "maximum_spacing_between_visits",
  "Exclude resources": "exclude_resources",
  "Assign resources": "assign_resources",
  "Compatibility with the resources": "compatibility_with_the_resources",
  "Require all skills to be compatible": "require_all_skills_to_be_compatible",
  "To visit": "to_visit",
  "Type": "type",
  "End visit before closing time": "end_visit_before_closing_time",
  "Starts before": "starts_before",
  "Lateness tolerance": "lateness_tolerance",
  "Penalty per late hour": "penalty_per_late_hour",
  "Outsourcing cost": "outsourcing_cost",
  "Email Address": "email_address",
  "Get notifications": "get_notification",
  "Mobile phone": "mobile_phone",
  "Evaluation mode - Name of resource": "evaluation_mode_name_of_resource",
  "Evaluation mode - Day of visit": "evaluation_mode_day_of_visit",
  "Evaluation mode - Order number": "evaluation_mode_order_number",
  // "Quantity(Volume)": "quantity_volume",
  // "Assign resources": "assign_resources",
  // "Type": "type"
};
const optimaBulkUploadHeaderMapping = {
      mandatoryHeaders: {
        'Sales Doc./Delivery Number/Material Invoice Number': 'delivery_number',
        'Pickup Ref Id': 'gate_ref_id',
        'Customer/Ship To Ref Id': 'ship_to',
        'Sold To Ref Id': 'sold_to',
        'Material Code': 'material_code',
        'Order Quantity': 'quantity',
        'Quantity Unit': 'quantity_unit',
        'Weight': 'weight',
        'Weight Unit': 'weight_unit',
        'Volume': 'volume',
        'Volume Unit': 'volume_unit',
      },
      nonMandatoryHeaders: {
        'Division': 'division',
        'Material Category': 'category',
        'Sub Category': 'sub_category',
        'Delivery Type': 'delivery_type',
        'Delivery Date(YYYY-MM-DD)': 'delivery_date',
        'Date(YYYY-MM-DD)': 'date',
        'Invoice Date(YYYY-MM-DD)': 'invoice_date',
        'Delivery Status': 'delivery_status',
        'Invoice Value': 'invoice_value',
        'Invoice Number': 'invoice_number',
        'MRP': 'mrp',
        'Line Item': 'ext_ref_id',
        'Stack Norm Ratio': 'stock_norm_ratio',
        'Vehicle Requirement Date': 'vehicle_requirement_date',
        'Order Type': 'order_type',
        'STN': 'stn',
        'Category Priority': 'category_priority',
        'Transporter Reference Id': 'transporter_ref_id',
        'Preferred Movement Via': 'preferred_movement_via',
        'Via Hub': 'via_hub',
        'Production Time': 'production_time',
        'Dock Ref Id': 'dock_ref_id',
        'Virtual Pickup Id': 'virtual_pickup_id',
        'Virtual Ship To Id': 'virtual_ship_to_id',
        'Virtual Sold To Id': 'virtual_sold_to_id',
        'LR Number': 'lr_number',
        'Package Ref Id': 'package_ref_id',
        'Package Id': 'group_id',
        'Package Volume': 'package_volume',
        'Package Weight': 'package_weight',
        'Material Thickness': 'thickness',
        'Load Sequence': 'load_sequence',
        'Can Telescope': 'can_telescope',
      },
      lastMileHeaders: {
        'Customer Name': 'customer_name',
        'Customer Reference Id': 'customer_ref_id',
        'Customer Reference Name': 'customer_rname',
        'Customer Address': 'customer_address',
        'Customer City': 'customer_city',
        'Customer State': 'customer_state',
        'Customer Pincode': 'customer_pincode',
        'Customer Region': 'customer_region',
        'Customer Country': 'customer_country',
        'Customer Mobile': 'customer_rmobile',
        'Customer Reference Email': 'customer_remail',
        'Customer Type': 'customer_type',
        'Customer Category': 'customer_category',
        'Customer Delivery Do Not Combine': 'customer_delivery_do_not_combine',
        'Customer Combine': 'customer_combine',
        'Customer Vehicle Type Exclude': 'customer_vehicle_type_exclude'
      },
};

module.exports = {
  optimaConfigConstants,
  optimaRejectionReason,
  optimaEditMode,
  MaterialUploadDateFormats,
  getModeOfOptimaExecution,
  getOptimaRejectionStages,
  getMaxRejectionsCountForDownloadDirectly,
  getMovementTypes,
  getMovementMap,
  Optima,
  toursolverVehicleUploadHeaders,
  toursolverOrderUploadHeaders,
  optimaDeliveryPicklistHeaderMapping,
  optimaBulkUploadHeaderMapping,
  defaultOrderCreation,
  defaultCategoryPriorities,
};
